"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AffiliatePrograms = exports.TrackingPixels = exports.TrackingLinks = exports.WebsiteIntegrations = exports.DiscountAndAccessCodes = exports.EmailInvitations = exports.APO = exports.FacebookTicketClass = exports.Facebook = exports.Waitlist = exports.CustomQuestion = exports.Question = exports.OrderForm = exports.TicketClass = exports.EventSchedule = exports.Event = exports.CoyoteRepeatingEventSelector = void 0;

var _analyticsModelSchema = require("./analyticsModelSchema");

var CoyoteRepeatingEventSelector = {
  viewed: function viewed(_ref) {
    var isFlagEnabled = _ref.isFlagEnabled;
    return _analyticsModelSchema.Analytics.event({
      object: 'CoyoteRepeatingEventSelector',
      action: 'Viewed',
      properties: {
        isFlagEnabled: {
          type: 'label',
          value: isFlagEnabled
        }
      }
    });
  }
};
exports.CoyoteRepeatingEventSelector = CoyoteRepeatingEventSelector;
var Event = {
  created: function created() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Event',
      action: 'Created'
    });
  },
  discarded: function discarded() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Event',
      action: 'Discarded'
    });
  },
  saved: function saved() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Event',
      action: 'Saved'
    });
  },
  previewed: function previewed() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Event',
      action: 'Previewed'
    });
  },
  published: function published() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Event',
      action: 'Published'
    });
  },
  unpublished: function unpublished() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Event',
      action: 'Unpublished'
    });
  },
  deleted: function deleted() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Event',
      action: 'Deleted'
    });
  },
  cancelled: function cancelled() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Event',
      action: 'Cancelled'
    });
  },
  copied: function copied() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Event',
      action: 'Copied'
    });
  },
  viewed: function viewed() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Event',
      action: 'Viewed'
    });
  }
};
exports.Event = Event;
var EventSchedule = {
  created: function created(_ref2) {
    var scheduleId = _ref2.scheduleId;
    return _analyticsModelSchema.Analytics.event({
      object: 'EventSchedule',
      action: 'Created',
      properties: {
        scheduleId: {
          type: 'label',
          value: scheduleId
        }
      }
    });
  }
};
exports.EventSchedule = EventSchedule;
var TicketClass = {
  created: function created() {
    return _analyticsModelSchema.Analytics.event({
      object: 'TicketClass',
      action: 'Created'
    });
  },
  saved: function saved() {
    return _analyticsModelSchema.Analytics.event({
      object: 'TicketClass',
      action: 'Saved'
    });
  },
  deleted: function deleted() {
    return _analyticsModelSchema.Analytics.event({
      object: 'TicketClass',
      action: 'Deleted'
    });
  }
};
exports.TicketClass = TicketClass;
var OrderForm = {
  saved: function saved() {
    return _analyticsModelSchema.Analytics.event({
      object: 'OrderForm',
      action: 'Saved'
    });
  }
};
exports.OrderForm = OrderForm;
var Question = {
  enabled: _analyticsModelSchema.Analytics.event({
    object: 'Question',
    action: 'Enabled'
  }),
  disabled: _analyticsModelSchema.Analytics.event({
    object: 'Question',
    action: 'Disabled'
  })
};
exports.Question = Question;
var CustomQuestion = {
  saved: function saved() {
    return _analyticsModelSchema.Analytics.event({
      object: 'CustomQuestion',
      action: 'Saved'
    });
  },
  deleted: function deleted() {
    return _analyticsModelSchema.Analytics.event({
      object: 'CustomQuestion',
      action: 'Deleted'
    });
  }
};
exports.CustomQuestion = CustomQuestion;
var Waitlist = {
  saved: function saved() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Waitlist',
      action: 'Saved'
    });
  }
};
exports.Waitlist = Waitlist;
var Facebook = {
  clicked: function clicked() {
    return _analyticsModelSchema.Analytics.event({
      object: 'Facebook',
      action: 'Clicked'
    });
  }
};
exports.Facebook = Facebook;
var FacebookTicketClass = {
  added: function added() {
    return _analyticsModelSchema.Analytics.event({
      object: 'FacebookTicketClass',
      action: 'Added'
    });
  },
  removed: function removed() {
    return _analyticsModelSchema.Analytics.event({
      object: 'FacebookTicketClass',
      action: 'Removed'
    });
  }
};
exports.FacebookTicketClass = FacebookTicketClass;
var APO = {
  saved: function saved() {
    return _analyticsModelSchema.Analytics.event({
      object: 'APO',
      action: 'Saved'
    });
  }
}; // TBD

exports.APO = APO;
var EmailInvitations = {};
exports.EmailInvitations = EmailInvitations;
var DiscountAndAccessCodes = {};
exports.DiscountAndAccessCodes = DiscountAndAccessCodes;
var WebsiteIntegrations = {};
exports.WebsiteIntegrations = WebsiteIntegrations;
var TrackingLinks = {};
exports.TrackingLinks = TrackingLinks;
var TrackingPixels = {};
exports.TrackingPixels = TrackingPixels;
var AffiliatePrograms = {};
exports.AffiliatePrograms = AffiliatePrograms;
//# sourceMappingURL=analyticsModel.js.map